import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

import { trackCianDobroBannerClick, trackCianDobroBannerShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { CianDobroBanner } from '../../components/CianDobroBanner';

type TCianDobroBannerInfo = {
  header: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
  logoUrl: string;
};

export function CianDobroBannerContainer() {
  const { config } = useApplicationContext();
  const bannerInfo = config.get<TCianDobroBannerInfo>('cian-dobro.desktopSerpBannerInfo');

  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(() => {
    trackCianDobroBannerClick(jsonQuery, source);
  }, [jsonQuery, source]);

  const handleShow = React.useCallback(() => {
    trackCianDobroBannerShow(jsonQuery, source);
  }, [jsonQuery, source]);

  if (
    !bannerInfo ||
    !bannerInfo.header ||
    !bannerInfo.text ||
    !bannerInfo.buttonText ||
    !bannerInfo.buttonUrl ||
    !bannerInfo.logoUrl
  ) {
    return null;
  }

  return <CianDobroBanner {...bannerInfo} onShow={handleShow} onClick={handleClick} />;
}
